import { faAddressCard } from "@fortawesome/free-regular-svg-icons";
import { Routes } from "../../../routes";
import {
  faBabyCarriage,
  faBoxTissue,
  faCoins,
  faFileContract,
  faMoneyBill,
  faPiggyBank,
} from "@fortawesome/free-solid-svg-icons";
import {
  fa500px,
  faAccessibleIcon,
  faAccusoft,
  faAdn,
  faAngellist,
  faCcPaypal,
  faReacteurope,
} from "@fortawesome/free-brands-svg-icons";

export const mainTreasuryModules = [
  {
    title: "Dashboard",
    route: Routes.DashboardOverview.path,
    icon: faAddressCard,
  },
  // {
  //   title: "TSA Funding",
  //   route: Routes.tsafunding.faacTsaFunding,
  //   icon: faAddressCard,
  //   subMenu: [
  //     {
  //       title: "FAAC TSA Funding",
  //       route: Routes.tsafunding.faacTsaFunding + "/FAAC TSA Funding",
  //     },
  //     {
  //       title: "JAAC TSA Funding",
  //       route: Routes.tsafunding.faacTsaFunding + "/JAAC TSA Funding",
  //     },
  //     {
  //       title: "IGR Collection",
  //       route: Routes.tsafunding.NewFundingIGR,
  //     },
  //     {
  //       title: "Aids and Grant",
  //       route: Routes.tsafunding.NewFundingAidAndGrand,
  //     },

  //     {
  //       title: "Debt Management",
  //       route: Routes.tsafunding.NewFundingDebt,
  //     },
  //     {
  //       title: "Asset Management",
  //       route: Routes.tsafunding.NewFundingAsset,
  //     },
  //     {
  //       title: "Asset Disposal",
  //       route: Routes.tsafunding.AssetDisposal,
  //     },
  //       { title: "Economic Mapping",
  //   route: Routes.tsafunding.MdaMapping,
  //   // icon: faAddressCard,
  // },
  // { title: "Account Chart Opening Balances",
  //   route: Routes.tsafunding.acct_opening_bal,
  //   // icon: faAddressCard,
  // },
  //   ],
  // },

  // {
  //   title: "TSA Transfer",
  //   route: Routes.tsafunding.tsaTransfers,
  //   icon: faAddressCard,
  // },

  {
    title: "Budget",
    route: Routes.budget.budgetUtlization,
    icon: faMoneyBill,
    subMenu: [
      {
        title: "Budget Utilization",
        route: Routes.budget.budgetUtlization,
      },
      {
        title: "Upload Budget",
        route: Routes.budget.uploadBudget,
      },
    ],
  },
  {
    title: "MDA Banks",
    route: Routes.bank.bankIndex,
    icon: faPiggyBank,
  },
  {
    title: "Accountant General",
    route: Routes.approval.agApprovalDashboard,
    icon: faBoxTissue,
    subMenu: [
      {
        title: "Recurrent Releases",
        route: Routes.approval.agApprovalDashboard,

        subMenu: [
          {
            title: "Scheduled Releases",
            route: Routes.approval.agApprovalDashboard ,
          },
          {
            title: "Payments",
            route: Routes.approval.agApprovalDashboard2 ,
          },
        ],
      },
      {
        title: "Capital Releases",
        route: Routes.approval.agApprovalDashboard,

        subMenu: [
          {
            title: "Payment Schedule",
            route: Routes.pv.paymentPvScheduleIndex,
          },
          {
            title: "Payments",
            route: Routes.pv.PaymentDetails,
          },
        ],
      },
      {
        title: "AG Releases",
        route: Routes.approval.agReleases,
      },
      {
        title: "AG Approved Releases",
        route: Routes.approval.agApprovedReleases,
      },
    ],
  },
  // {
  //   title: "Collection For Release",
  //   route: Routes.approval.approvalIndex,
  //   icon: faBoxTissue,
  //   subMenu: [
  //     {
  //       title: "Pending Releases",
  //       route: Routes.approval.pendingApproval,
  //     },
  //     {
  //       title: "Review Releases",
  //       route: Routes.approval.reviewReleases,
  //     },
  //     {
  //       title: "Approve Releases",
  //       route: Routes.approval.approvalReleases,
  //     },
  //     {
  //       title: "All Releases",
  //       route: Routes.approval.approvalIndex,
  //     },
  //     {
  //       title: "Auditor Releases Dashboard",
  //       route: Routes.approval.auditorGeneralApprovalDashboard,
  //     },
  //     {
  //       title: "AD Exp. Control Releases",
  //       route: Routes.approval.adExpContrReleases,
  //     },
  //   ],
  // },

  {
    title: "MDAs Dashboard",
    route: Routes.DashboardOverview,
    icon: faCcPaypal,
    subMenu: [
      {
        title: "Generate PV",
        // route: Routes.pv.pvlIndex,
        route: Routes.subTreasury.capitalRelease,
      },
      {
        title: "Upload Signed PV",
        // route: Routes.pv.pvCheckIndex,
        route: Routes.pv.pvCheckedIndex,
      },
      // {
      //   title: "AD PV",
      //   route: Routes.pv.pvADCheckIndex,
      // },
      // {
      //   title: "AG PV Review",
      //   // route: Routes.pv.pvReviewIndex,
      //   route: Routes.pv.agPvCheckIndex,
      // },
      {
        title: "ST Dashboard",
        // route: Routes.pv.pvApproveIndex,
        route: Routes.pv.stPvCheckIndex,
      },
      {
        title: "Inspection PV Review",
        // route: Routes.pv.pvReports,
        route: Routes.pv.inspectionPvCheckIndex,
      },
      // {
      //   title: "ST Generate Payment Schedule",
      //   route: Routes.pv.auditorpvReports,
      //   route: Routes.pv.paymentPvScheduleIndex,
      // },
    ],
  },
  // {
  //   title: "Cash Backing",
  //   route: Routes.DashboardOverview,
  //   icon: faCoins,
  //   subMenu: [
  //     {
  //       title: "Pending Cash Backing",
  //       route: Routes.cashBacking.cashBackinPending,
  //     },
  //     {
  //       title: "Review Cash Backing",
  //       route: Routes.cashBacking.cashBackinReview,
  //     },
  //     {
  //       title: "Approve Cash Backing",
  //       route: Routes.cashBacking.cashBackinApproved,
  //     },
  //   ],
  // },
  // {
  //   title: "Payments",
  //   route: Routes.DashboardOverview,
  //   icon: faAccessibleIcon,
  //   subMenu: [
  //     // {
  //     //   title: "Raise Payment Request",
  //     //   route: Routes.paymentRequest.raisePaymentRequest,
  //     // },
  //     // {
  //     //   title: "Review Payment Request",
  //     //   route: Routes.paymentRequest.reviewPaymentRequest,
  //     // },
  //     {
  //       title: "Approve Payment Request",
  //       route: Routes.paymentRequest.approvePaymentRequest,
  //     },

  //     {
  //       title: "Direct Transfer",
  //       route: Routes.paymentRequest.directTransferList,
  //     },
  //   ],
  // },
  // {
  //   title: "Self Accounting MDA",
  //   route: Routes.DashboardOverview,
  //   icon: faAccessibleIcon,
  //   subMenu: [
  //     {
  //       title: "Cash Backing Request",
  //       route: Routes.cashBacking.cashBackingRequest,
  //     },
  //   ],
  // },

  {
    title: "Expenditure Control",
    route: Routes.DashboardOverview,
    icon: faFileContract,
    subMenu: [
      // {
      //   title: "Receiving Office",
      //   route: Routes.expenditureControl.receivingOfficeIndex,
      // },

      // {
      //   title: "Expenditure Control",
      //   route: Routes.expenditureControl.expControlIndex,
      // },
      // {
      //   title: "Review Release",
      //   route: Routes.expenditureControl.receivingOfficeRelease,
      // },
      // {
      //   title: "Payment Schedule",
      //   route: Routes.expenditureControl.expControlScheduleIndex,
      // },
      //    {
      //   title: "Payment Schedule Recurrent" ,
      //   route: Routes.expenditureControl.expControlScheduleIndexRec,
      // },
           {
        title: "Payment Schedule Recurrent",
        route: Routes.expenditureControl.expControlScheduleIndexRec2,
      },
    ],
  },
  // {
  //   title: "Dir. Exp. Control",
  //   route: Routes.DashboardOverview,
  //   icon: faAccusoft,
  //   subMenu: [
  //     // {
  //     //   title: "Reveiw PVs",
  //     //   route: Routes.expenditureControl.dirExpIndex,
  //     // },
  //     {
  //       title: "Review PVs",
  //       route: Routes.expenditureControl.dirExpFinalIndex,
  //     },
  //     {
  //       title: "Review Payment Schedule",
  //       route: Routes.expenditureControl.dirExpPaymentScheduleIndex,
  //     },
  //   ],
  // },

   {
    title: "Dir Treasury",
    route: Routes.DashboardOverview,
    icon: faAccusoft,
    subMenu: [
      // {
      //   title: "Reveiw PVs",
      //   route: Routes.expenditureControl.dirExpIndex,
      // },
      {
        title: "Review Release",
        route: Routes.expenditureControl.dirTreasuryIndex,
      },
     
    ],
  },
  // {
  //   title: "Ass. Dir. Exp. Control",
  //   route: Routes.DashboardOverview,
  //   icon: faAccusoft,
  //   subMenu: [
  //     // {
  //     //   title: "Review PV (ADEC)",
  //     //   route: Routes.expenditureControl.assDirExpIndex,
  //     // },
  //     // {
  //     //   title: "AD Exp. PV Reviewal",
  //     //   route: Routes.expenditureControl.assDirFinalExpIndex,
  //     // },
  //     {
  //       title: "Review Payment Schedule",
  //       route: Routes.expenditureControl.assDirPsIndex,
  //     },
  //   ],
  // },
  // {
  //   title: "DAG",
  //   route: Routes.DashboardOverview,
  //   icon: fa500px,
  //   subMenu: [
  //     {
  //       title: "Approve PVs (DAG)",
  //       route: Routes.dag.dagPendingPVIndex,
  //     },
  //     {
  //       title: "Approve Schedules",
  //       route: Routes.dag.dagIndex,
  //     },
  //   ],
  // },
  // {
  //   title: "Sub Treasury",
  //   route: Routes.DashboardOverview,
  //   icon: faAngellist,
  //   subMenu: [
  //     {
  //       title: "Receiving Office (ST)",
  //       route: Routes.subTreasury.receivingOfficeIndex,
  //     },
  //     {
  //       title: "Checking Office (ST)",
  //       route: Routes.subTreasury.checkingOfficeIndex,
  //     },
  //     // {
  //     //   title: "Cheques Office (ST)",
  //     //   route: Routes.subTreasury.headChequesOfficeIndex,
  //     // },
  //     {
  //       title: "Cash Office (ST)",
  //       route: Routes.subTreasury.headChequesOfficeIndex,
  //     },
  //     {
  //       title: "DST",
  //       route: Routes.subTreasury.dstOfficeIndex,
  //     },
  //     {
  //       title: "Review Payment (DST)",
  //       route: Routes.subTreasury.dstPendingScheduleOfficeIndex,
  //     },
  //     {
  //       title: "Sub Treasurer",
  //       route: Routes.subTreasury.subTreasurerPaymentReviewOfficeIndex,
  //     },
  //     {
  //       title: "Approved Payments",
  //       route: Routes.subTreasury.approvedPaymentsIndex,
  //     },
  //   ],
  // },
  // {
  //   title: "Remittance",
  //   route: Routes.DashboardOverview,
  //   icon: faBabyCarriage,
  //   subMenu: [
  //     {
  //       title: "Remittance Slip",
  //       route: Routes.remittance.index,
  //     },
  //   ],
  // },
  // {
  //   title: "Reports",
  //   route: Routes.DashboardOverview,
  //   icon: faReacteurope,
  //   subMenu: [
  //     {
  //       title: "Budget Utilization Reports",
  //       route: Routes.budget.budgetUtlization,
  //     },
  //     {
  //       title: "Expenditure Reports",
  //       route: Routes.reports.expenditureReport,
  //     },
  //     {
  //       title: "Cash Flow statements",
  //       route: Routes.reports.cashFlowReport,
  //     },
  //     {
  //       title: "Income and Expenses statements",
  //       route: Routes.reports.incomeExpensesReport,
  //     },
  //     {
  //       title: "Financial Reports statements",
  //       route: Routes.reports.financialReport,
  //     },
  //     {
  //       title: "Trial Balance statements",
  //       route: Routes.reports.trialBalanceReport,
  //     },
  //     {
  //       title: "General Ledger statements",
  //       route: Routes.reports.generalLedgerReport,
  //     },
  //     {
  //       title: "Notes Statements",
  //       route: Routes.reports.noteReport,
  //     },
  //     {
  //       title: "Overhead Reports",
  //       route: Routes.reports.overHead,
  //     },
  //   ],
  // },

  // {
  //   title: "Accounts",
  //   route: Routes.DashboardOverview,
  //   icon: faReacteurope,
  //   subMenu: [
  //     // {
  //     //   title: "Manage Accounts",
  //     //   route: Routes.account.manageAccount,
  //     // },
  //     {
  //       title: "Manage Main Accounts",
  //       route: `${Routes.account.manageAccountMain}/MAIN ACCOUNT`,
  //     },
  //     {
  //       title: "Manage Sub Accounts",
  //       route: `${Routes.account.manageAccountMain}/SUB-TREASURY ACCOUNT`,
  //     },
  //     {
  //       title: "Manage Other Accounts",
  //       route: `${Routes.account.manageAccountMain}/OTHERS`,
  //     },
  //     {
  //       title: "Payment Reports",
  //       route: Routes.account.accountReport,
  //     },
  //   ],
  // },
  // {
  //   title: "Dashboard",
  //   route: Routes.DashboardOverview.path,
  //   icon: faAddressCard,
  // },
  // {
  //   title: "Admin",
  //   route: Routes.userAdmin.index + "?role=admin",
  //   icon: faReacteurope,
  // },
  // {title: "Payment Schedule", route: Routes.DashboardOverview },
 { title: "Internal Audit", route: Routes.auditordashboard.auditorIndex },
  // {title: "Payments", route: Routes.DashboardOverview },
  // {title: "Remittance", route: Routes.DashboardOverview },
  // {title: "Reports", route: Routes.DashboardOverview },
  // { title: "Tax Setup", route: Routes.DashboardOverview },
  // { title: "Auditor Dashboard", route: Routes.auditordashboard.auditorIndex },
  // { title: "Tax Setup", route: Routes.taxSetup.taxIndex },
  // {title: "Auditor Dashboard", route: Routes.auditordashboard.auditorIndex },
  // {title: "Admin", route: Routes.DashboardOverview },
];